"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8822],{

/***/ 4847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useImageDataHandler; }
/* harmony export */ });
/* unused harmony export imageDataHandler */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9366);
/* harmony import */ var _util_magnolia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7581);
/* harmony import */ var _util_viewport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5625);





/**
 * Hook to generate an image handler function.
 *
 * Options can be passed to handler function to optimise image size.
 * If the image does not to bigger than "sm" in any viewport, then
 * `maxViewport` option should be set to `Viewport.sm`.
 *
 * Image sizes (width) for each viewport size:
 * - xs: 600px
 * - sm: 800px
 * - md: 900px
 * - lg: 1024px
 * - xl: 1440px
 */ function useImageDataHandler() {
    var isPreview = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().isPreview;
    var viewport = (0,_contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().viewport;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(image, options) {
        return imageDataHandler(image, viewport, isPreview, options);
    }, [
        isPreview,
        viewport
    ]);
}
/**
 * Get image information from MGNL (MGNL = Magnolia)
 * @param image - Image object from MGNL
 * @param viewport - Viewport from store
 * @returns Object containing "imageSrc" (image url), "imageLoader" (loader to handle next/image)
 *  and boolean "fallback", to show a fallback image if current image is not published in MGNL
 */ function imageDataHandler(image, viewport) {
    var isPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, options = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof image === "string" || !image) return {
        src: "",
        width: 0,
        height: 0,
        imageLoader: undefined,
        imageSrc: ""
    };
    var _metadata = image.metadata, width = _metadata.width, height = _metadata.height;
    var src = (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image["@link"], isPreview).toString();
    var optimisedViewport = (0,_util_viewport__WEBPACK_IMPORTED_MODULE_4__/* .optimiseViewport */ .s)(viewport, options);
    var imageLoader = function() {
        var ref;
        return optimisedViewport && ((ref = image.renditions) === null || ref === void 0 ? void 0 : ref[optimisedViewport].link) ? (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image.renditions[optimisedViewport].link, isPreview) : src;
    };
    return {
        src: src,
        width: width,
        height: height,
        imageLoader: imageLoader,
        imageSrc: src
    };
}


/***/ }),

/***/ 8822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ EventsPage; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useKeyDown-88662051.mjs
var useKeyDown_88662051 = __webpack_require__(403);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-55c64a80.mjs
var useClickOutside_55c64a80 = __webpack_require__(7720);
// EXTERNAL MODULE: ../wif-ui-lib/dist/VideoIcon-c13b94d3.mjs
var VideoIcon_c13b94d3 = __webpack_require__(3652);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-460da2fc.mjs
var Link_460da2fc = __webpack_require__(1607);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-eec2778c.mjs
var Button_eec2778c = __webpack_require__(9358);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Icon-e01b6482.mjs
var Icon_e01b6482 = __webpack_require__(2007);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-be3826ec.mjs
var Image_be3826ec = __webpack_require__(567);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/EventHero.js












const y = "registration", I = "registration__video-container", R = "registration__information", S = "button", u = {
  registration: y,
  registrationVideoContainer: I,
  registrationInformation: R,
  button: S
};
function _(c) {
  const {
    eventStartDate: i,
    eventEndDate: t,
    eventLocation: r,
    eventLink: n,
    translations: o = {},
    locale: a
  } = c, {
    location: g = "Location",
    time: p = "Time",
    link: v = "Register"
  } = o, { textDate: E, isMultiDayEvent: f } = b(
    i,
    t,
    a
  ), m = f ? void 0 : B(i, t, a);
  return /* @__PURE__ */ react.createElement("span", { className: u.registration }, /* @__PURE__ */ react.createElement("div", { className: u.registrationVideoContainer }, /* @__PURE__ */ react.createElement(
    VideoIcon_c13b94d3.V,
    {
      src: "/static/videos/Icon_Calendar.mp4",
      fallbackImgSrc: "/static/images/Icon_Calendar.svg"
    }
  )), /* @__PURE__ */ react.createElement(
    "dl",
    {
      className: (0,useKeyDown_88662051.c)(
        u.registrationInformation,
        useKeyDown_88662051.t.textsLeadText
      )
    },
    /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement("dt", { style: { display: "none" } }, "Date"), /* @__PURE__ */ react.createElement("dd", { className: useKeyDown_88662051.t.textsLeadTextBold }, E)),
    m ? /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement("dt", null, p, ": "), /* @__PURE__ */ react.createElement("dd", null, m)) : null,
    r ? /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement("dt", null, g, ": "), /* @__PURE__ */ react.createElement("dd", null, r)) : null,
    n ? /* @__PURE__ */ react.createElement(Link_460da2fc.L, { href: n, disableLinkTextStyle: !0 }, /* @__PURE__ */ react.createElement(
      Button_eec2778c.B.Secondary,
      {
        asDiv: !0,
        text: v,
        icon: Icon_e01b6482.W.ARROW_UP_RIGHT
      }
    )) : null
  ));
}
function b(c, i, t = "en-US") {
  const r = {
    weekday: void 0,
    year: "numeric",
    month: "long",
    day: "numeric"
  }, n = c.toLocaleDateString(t, r), o = i?.toLocaleDateString(t, r), a = o ? n !== o : !1;
  return {
    textDate: a ? `${n} — ${o}` : n,
    isMultiDayEvent: a
  };
}
function B(c, i, t = "en-US") {
  const r = new Intl.Locale(t), n = {
    timeStyle: "short",
    timeZone: "Europe/Helsinki"
  }, o = c.toLocaleTimeString(r, n).toLocaleLowerCase(), a = i?.toLocaleTimeString(r, n).toLocaleLowerCase();
  return !a || a === o ? o : `${o} - ${a}`;
}
const w = "event-hero-block-content", P = "event-hero-title", W = "event-hero", $ = "desktop", A = "hero-wrapper", V = "image-reference", O = "information", G = "registration", M = "event-hero-lead-text", U = "event-hero-description", s = {
  eventHeroBlockContent: w,
  eventHeroTitle: P,
  eventHero: W,
  desktop: $,
  heroWrapper: A,
  imageReference: V,
  information: O,
  registration: G,
  eventHeroLeadText: M,
  eventHeroDescription: U
};
function ne(c) {
  const {
    title: i,
    image: t,
    imageReference: r,
    leadText: n,
    description: o,
    altText: a,
    isLargeDesktop: g,
    locale: p,
    ...v
  } = c, E = (0,useKeyDown_88662051.c)(useKeyDown_88662051.t.pageHeading, s.eventHeroTitle), f = (0,useKeyDown_88662051.c)(s.imageReference), m = (0,useKeyDown_88662051.c)(
    useKeyDown_88662051.t.textsComponentTitleBold,
    s.eventHeroLeadText
  ), L = (0,useKeyDown_88662051.c)(
    useKeyDown_88662051.t.textsLeadText,
    s.eventHeroDescription
  );
  return /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B, { bottomPadding: useClickOutside_55c64a80.a.LARGE, topPadding: useClickOutside_55c64a80.a.SMALL }, /* @__PURE__ */ react.createElement(useClickOutside_55c64a80.B.Content, { className: s.eventHeroBlockContent }, /* @__PURE__ */ react.createElement("h1", { className: E }, i), /* @__PURE__ */ react.createElement("div", { className: s.heroWrapper }, /* @__PURE__ */ react.createElement(
    Image_be3826ec.I,
    {
      className: s.eventHero,
      src: t.imageSrc,
      width: t.width,
      height: t.height,
      altText: a,
      imageLoader: t.imageLoader,
      styling: Image_be3826ec.a.ARTICLE_PAGE_HERO,
      "data-testid": "event-page-hero-image"
    }
  ), /* @__PURE__ */ react.createElement(
    "div",
    {
      className: f,
      "data-testid": "event-hero-image-reference"
    },
    /* @__PURE__ */ react.createElement("p", { itemProp: "citation", className: useKeyDown_88662051.t.textsCaption }, r)
  )), /* @__PURE__ */ react.createElement(_, { locale: p, ...v }), g ? /* @__PURE__ */ react.createElement("div", { className: s.information }, /* @__PURE__ */ react.createElement("p", { className: m }, n), /* @__PURE__ */ react.createElement("div", { className: L }, o)) : /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("p", { className: m }, n), /* @__PURE__ */ react.createElement("div", { className: L }, o))));
}

//# sourceMappingURL=EventHero.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
;// CONCATENATED MODULE: ./src/magnolia/templates/EventsPage/EventHero/EventHero.tsx









var HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1682).then(__webpack_require__.bind(__webpack_require__, 1682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1682)
            ];
        }
    }
});
function EventHero(props) {
    var eventDateStart = props.eventDateStart, eventDateEnd = props.eventDateEnd, image = props.image, heroTitle = props.heroTitle, heroDescription = props.heroDescription, eventLink = props.eventLink, eventLocation = props.eventLocation, eventLinkLabel = props.eventLinkLabel, eventLocationLabel = props.eventLocationLabel, eventTimeLabel = props.eventTimeLabel, altText = props.altText, imageReference = props.imageReference, leadText = props.leadText;
    var isLargeDesktop = (0,ViewportContext/* default */.Z)() === app/* Viewport.xl */.l_.xl;
    var locale = (0,router.useRouter)().locale;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var imageData = imageDataHandler(image);
    var eventDateStartAsDate = new Date(eventDateStart);
    var eventDateEndAsDate = eventDateEnd ? new Date(eventDateEnd) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ne, {
        title: heroTitle,
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser, {
            html: heroDescription
        }),
        image: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
            imageSrc: imageData.src
        }),
        altText: altText,
        imageReference: imageReference,
        leadText: leadText,
        eventLink: eventLink,
        eventLocation: eventLocation,
        isLargeDesktop: isLargeDesktop,
        eventStartDate: eventDateStartAsDate,
        eventEndDate: eventDateEndAsDate,
        translations: {
            link: eventLinkLabel,
            location: eventLocationLabel,
            time: eventTimeLabel
        },
        locale: locale
    });
}

// EXTERNAL MODULE: ./src/util/SmartEditableArea.tsx
var SmartEditableArea = __webpack_require__(1747);
;// CONCATENATED MODULE: ./src/magnolia/templates/EventsPage/EventsPage.tsx







function EventsPage(props) {
    var ref;
    var title = props.title, metaDescription = props.metaDescription, main = props.main, altText = props.altText, image = props.image, isPreview = props.isPreview;
    var articleImageUrl = (image === null || image === void 0 ? void 0 : (ref = image.renditions) === null || ref === void 0 ? void 0 : ref["xs"]) ? (0,magnolia/* formatAssetLink */.Qz)(image.renditions["xs"].link, isPreview) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title + app/* META_TITLE_SUFFIX */.A_
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }),
                    articleImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: articleImageUrl
                    }),
                    altText && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: altText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventHero, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartEditableArea/* SmartEditableArea */.Z, {
                isPreview: isPreview,
                slotNode: main
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/templates/EventsPage/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 1747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SmartEditableArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7378);
/* harmony import */ var _magnolia_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9937);





var EditableArea = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1341), __webpack_require__.e(7351)]).then(__webpack_require__.bind(__webpack_require__, 7351));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7351)
            ];
        }
    }
});
function SmartEditableArea(props) {
    var slotNode = props.slotNode, isPreview = props.isPreview;
    if (isPreview) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditableArea, {
                className: "EditableArea",
                content: slotNode
            })
        });
    }
    var pageNodes = ((slotNode === null || slotNode === void 0 ? void 0 : slotNode["@nodes"]) || []).map(function(name) {
        return slotNode === null || slotNode === void 0 ? void 0 : slotNode[name];
    }).filter(Boolean);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: pageNodes.map(function(node) {
            var NodeComponent = (0,_magnolia_config__WEBPACK_IMPORTED_MODULE_3__/* .getComponentForMagnoliaTemplate */ .rX)(node["mgnl:template"]);
            if (!NodeComponent) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NodeComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, node), node["@id"]);
        })
    });
}


/***/ })

}]);